import { render, staticRenderFns } from "./temas-listado.vue?vue&type=template&id=3c9baefa&"
import script from "./temas-listado.component.ts?vue&type=script&lang=ts&"
export * from "./temas-listado.component.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports